import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { IoClose } from 'react-icons/io5'
import { FaArrowRotateRight } from 'react-icons/fa6'
import { getTabTitle, useTabs } from './TabsContext'

// Sekme bu genişliğin altına düşünce iç boşluk azaltılır, başlığa daha çok yer kalır
const COMPACT_TAB_WIDTH = 110

// Chrome mantığı: sekmeler sığmadığında eşit şekilde daralır, çubuk taşmaz
const TabBar = () => {

    const nav = useNavigate()
    const { tabs, activeId, closeTab, refreshTab } = useTabs()
    const ref = useRef()
    const [barWidth, setBarWidth] = useState(0)
    // Sekme kapatılınca fare çubuktan çıkana kadar genişlikler sabit kalır, böylece sıradaki × imlecin altına gelir
    const [frozenWidth, setFrozenWidth] = useState()

    useEffect(() => {
        const observer = new ResizeObserver(([entry]) => setBarWidth(entry.contentRect.width))
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])

    const tabWidth = frozenWidth || barWidth / tabs.length
    const compact = barWidth > 0 && tabWidth < COMPACT_TAB_WIDTH

    const onClickClose = (e, id) => {
        e.stopPropagation()
        setFrozenWidth(e.currentTarget.parentElement.getBoundingClientRect().width)
        closeTab(id)
    }

    return (
        <div
            ref={ref}
            onMouseLeave={() => setFrozenWidth()}
            className='flex gap-x-1 overflow-hidden border-b border-zinc-300 px-5 pt-2 mb-2 dark:border-zinc-700'
        >
            {
                tabs.map(tab => {
                    const active = tab.id === activeId
                    const title = getTabTitle(tab.path)
                    return (
                        <div
                            key={tab.id}
                            title={title}
                            style={{ maxWidth: frozenWidth }}
                            onClick={() => !active && nav(tab.path)}
                            // Orta tık sekmeyi kapatır; × gibi son sekmede çalışmaz
                            onMouseDown={e => e.button === 1 && e.preventDefault()}
                            onAuxClick={e => e.button === 1 && tabs.length > 1 && closeTab(tab.id)}
                            className={`${active ? 'bg-white text-purple-700 border-zinc-300 border-b-white dark:bg-zinc-800 dark:text-zinc-100 dark:border-zinc-700 dark:border-b-zinc-800' : 'bg-zinc-200 text-zinc-600 border-transparent hover:bg-zinc-100 dark:bg-zinc-900 dark:text-zinc-400'} ${compact ? 'px-2' : 'px-3'} ${active ? 'min-w-[6rem]' : 'min-w-0'} -mb-px flex flex-1 basis-0 max-w-[11rem] items-center gap-x-1.5 cursor-pointer select-none rounded-t-md border py-1 text-sm duration-150`}
                        >
                            <span className='flex-1 truncate'>{title}</span>
                            {
                                active &&
                                <span
                                    title='Yenile'
                                    className='shrink-0 text-xs hover:scale-125 duration-150'
                                    onClick={e => {
                                        e.stopPropagation()
                                        refreshTab(tab.id)
                                    }}
                                >
                                    <FaArrowRotateRight />
                                </span>
                            }
                            {
                                tabs.length > 1 &&
                                <span
                                    title='Kapat'
                                    className='shrink-0 rounded-sm hover:bg-zinc-300 hover:text-red-600 duration-150 dark:hover:bg-zinc-700'
                                    onClick={e => onClickClose(e, tab.id)}
                                >
                                    <IoClose />
                                </span>
                            }
                        </div>
                    )
                })
            }
        </div>
    )
}

export default TabBar
